import { Pipe, PipeTransform } from '@angular/core';
import { ProductSearchViewModel, RelatedProperties, StringRelatedPropertyValue } from '@models/api-search.models';
import {
    getPerfectVariantMatch,
    getVariantMatch
} from '@features/product-detail/product-details/product-details.helpers';

@Pipe({
    name: 'getVariantFromRelatedProperty',
    standalone: true
})
export class GetVariantFromRelatedPropertyPipe implements PipeTransform {
    /**
     * Get the variants from the related property for the given product
     * @param relatedProperty - The related properties of the product (object with keys and values)
     * @param key - The key of the related property we are looking for
     * @param variants - All the variants of the product
     * @returns The variants that match the related property
     */
    transform(
        relatedProperty: RelatedProperties | unknown,
        key: keyof RelatedProperties | unknown,
        variants: ProductSearchViewModel[]
    ): ProductSearchViewModel[] {
        const relatedPropertyA = relatedProperty as RelatedProperties;
        const keyA = key as keyof RelatedProperties;

        const perfectMatch = getPerfectVariantMatch(variants, relatedPropertyA);
        if (perfectMatch) {
            return [perfectMatch];
        }

        const matches: ProductSearchViewModel[] = [];
        Object.entries(relatedPropertyA).forEach(([_, value]) => {
            const product = variants.find(v => {
                if (keyA === 'primaryColor') {
                    return getVariantMatch(v, keyA, value.key as StringRelatedPropertyValue);
                }

                return getVariantMatch(v, keyA, value.value as StringRelatedPropertyValue);
            });
            if (product) {
                matches.push(product);
            }
        });

        if (matches) {
            return matches;
        }

        return [];
    }
}
